import { Dialog } from '../../components/ui/Dialog';
import { TaskForm } from './ScheduledTasksSection';

// NewTaskDialog hosts the regular TaskForm inside a modal so the
// operator can fire a one-shot, schedule a cron or create a webhook
// from anywhere (top of the agent detail, future global compose
// shortcut, …) without scrolling to the Tasks tab first.
//
// The default selector is "Run now" — the most common case for the
// modal entry point, mirroring the previous "Run now" button.
export function NewTaskDialog({
  open,
  onClose,
  orgId,
  agentId,
}: {
  open: boolean;
  onClose: () => void;
  orgId: string;
  agentId: string;
}) {
  return (
    <Dialog open={open} onClose={onClose} title="New task">
      <TaskForm
        orgId={orgId}
        agentId={agentId}
        initialTriggerKind="manual"
        onCancel={onClose}
        onSaved={onClose}
      />
    </Dialog>
  );
}
